import Hero from '../components/Hero'
import CountUpMetrics from '../components/CountUpMetrics'
import TrustpilotReview from '../components/TrustpilotReview'
import About from '../components/About'
import ServicesOverview from '../components/ServicesOverview'
// import VideoSection from '../components/VideoSection'
import QuotationCTA from '../components/QuotationCTA'
import UKCoverageMap from '../components/UKCoverageMap'
import LazySection from '../components/LazySection'
import heatPumpImage from '../assets/images/heat_pump_presentation_homepage.png'

const Home = () => {
  const heroContent = {
    title: 'Harnessing Earth\'s power for a sustainable future',
    subtitle: 'Benefit from economically & environmental alternatives',
    description: 'Reduce your energy bills by up to 70% while creating a more sustainable future for your family.',
    image: heatPumpImage,
    imageAlt: 'Modern air source heat pump installation',
    ctaText: 'Get Instant Quote',
    ctaLink: '/quote/heat-pumps',
    secondaryCtaText: 'Learn More',
    secondaryCtaLink: '#about'
  }

  return (
    <div>
      <Hero
        layout="split"
        showQuoteForm={true}
        content={heroContent}
      />
      <CountUpMetrics />
      <LazySection>
        <TrustpilotReview />
      </LazySection>
      <LazySection>
        <About />
      </LazySection>
      <LazySection>
        <ServicesOverview />
      </LazySection>
      {/* <LazySection>
        <VideoSection />
      </LazySection> */}
      <LazySection>
        <section className="section-padding bg-gray-50">
          <div className="container-custom">
            <UKCoverageMap />
          </div>
        </section>
      </LazySection>
      <LazySection>
        <QuotationCTA />
      </LazySection>
    </div>
  )
}

export default Home